import angular from 'angular';
import receiptProductInputTemplate from './receiptProductInput.html';

/*******************************************************************************
 * @ngdoc    component
 * @name     csm.books.WriteReceipts.component:receiptItemInput
 * @description
 * WriteReceipts product sale/order and editing.
 *******************************************************************************/
export const receiptProductInputComponent = {
  require: { appCtrl: '^^writeReceipts' },
  template: receiptProductInputTemplate,
  controller: controller
};

/*******************************************************************************
 * controller */
/**
 * Controller for the receipt product input.
 *******************************************************************************/
/* @ngInject */ function controller(
  $scope,
  $timeout,
  Alert,
  BooksSettings,
  BooksSvc,
  ReceiptEventTypes,
  SERVER,
  Tools
) {
  /*****************************************************************************
   * Constants
   *****************************************************************************/
  /** Donation Item Type. */ var IT_DONATION =
    SERVER.BooksDBConstants.IT_DONATION;
  /** Group Item Type. */ var IT_GROUP = SERVER.BooksDBConstants.IT_GROUP;
  /** Membership Item Type. */ var IT_MEMBERSHIP =
    SERVER.BooksDBConstants.IT_MEMBERSHIP;
  /** Group Subtype. */ var LIS_ITEM_GROUP =
    SERVER.BooksDBConstants.LIS_ITEM_GROUP;
  /** Membership Subtype. */ var LIS_MEMBERSHIP =
    SERVER.BooksDBConstants.LIS_MEMBERSHIP;
  /** Item Order Type. */ var LIT_ITEM_ORDER =
    SERVER.BooksDBConstants.LIT_ITEM_ORDER;
  /** Item Sale Type. */ var LIT_ITEM_SALE =
    SERVER.BooksDBConstants.LIT_ITEM_SALE;

  /*****************************************************************************
   * Properties
   *****************************************************************************/
  var mOrigQty = 0; // Original edit item quantity. Used for discount recalculations.
  var mProduct = null; // Selected product for use with the getterSetter.

  var $ctrl = this;
  $ctrl.itemFor = null;
  $ctrl.entityLabel = BooksSettings.addressEntityLabel; // Utilize the addressEntityLabel labelFunction.
  $ctrl.valProduct = {}; // Validators Control Object.

  /*--------------------------------------*/
  /* Add event listeners to the main app. */
  /*--------------------------------------*/
  $ctrl.$postLink = function () {
    $ctrl.appCtrl.addEventListener(
      ReceiptEventTypes.EVENT_FOCUS_PRODUCT,
      focusOnProduct
    );
    $ctrl.appCtrl.addEventListener(
      ReceiptEventTypes.EVENT_EDIT_PRODUCT,
      startEdit
    );
    $ctrl.appCtrl.addEventListener(
      ReceiptEventTypes.EVENT_RESET_PRODUCT,
      reset
    );
  };

  /*--------------------------------------*/
  /* Ready the UI */
  /*--------------------------------------*/
  reset();

  /*****************************************************************************
   * getterSetter: selectedProduct */
  /**
   * Accessor for the current working productListItem. Set up the $ctrl.receiptItem
   * according to the product properties;
   *****************************************************************************/
  $ctrl.selectedProduct = function (product) {
    /*-------------------------*/
    /* Getter: Return mProduct */
    /*-------------------------*/
    if (!arguments.length) return mProduct;

    /*-------------------------------------------*/
    /* Setter: Only update if this isn't an edit */
    /*-------------------------------------------*/
    if ($ctrl.isEdit) return;

    /** Utility function to convert ProductListItems to the ReceiptItem structure.
      If a ReceiptItem reference isn't available, a new object is instantiated. */
    var createReceiptItem = function (pli, ri) {
      /** Create a dummy product to clear values when there is no pli. */
      if (!pli)
        pli = {
          id: NaN,
          subItems: [],
          type: 0,
          name: '',
          amount: NaN,
          taxRate: 0
        };

      /** Instantiate the receiptItem reference if not available. */
      if (!ri) ri = {};

      var hasSubitems = pli.subItems && pli.subItems.length > 0;

      ri.itemID = pli.id;
      ri.type =
        pli.type == IT_DONATION
          ? SERVER.BooksDBConstants.LIT_DONATION_PURCHASE
          : 0;
      ri.subType =
        hasSubitems || pli.type == IT_GROUP
          ? LIS_ITEM_GROUP
          : pli.type == SERVER.BooksDBConstants.IT_MEMBERSHIP
            ? SERVER.BooksDBConstants.LIS_MEMBERSHIP
            : 0;
      ((ri.memo = pli.name),
        (ri.quantity = ri.qtyOrdered =
          !pli.id || pli.type == IT_DONATION ? 0 : 1));
      ri.price = pli.amount;
      ri.taxable = pli.taxable;
      ri.taxRate = pli.taxRate;
      ri.subItems = hasSubitems
        ? pli.subItems.map(function (si) {
            return createReceiptItem(si);
          })
        : [];

      return ri;
    };

    /*--------------------------------------*/
    /* Setter: Update $ctrl.receiptItem    */
    /* for the current product if available */
    /*--------------------------------------*/
    createReceiptItem((mProduct = product), $ctrl.receiptItem);
  };

  /*****************************************************************************
   * addProduct */
  /**
   * Validates the data and fields before creating a DGReceiptItem for use in the
   * rcptGrid.
   *
   * @param  forOrder  The item should be added as an Order Item.
   *****************************************************************************/
  function addProduct(forOrder) {
    Alert.clear();

    /*-------------------------------*/
    /* Validate an item is selected. */
    /*-------------------------------*/
    if (!$ctrl.valProduct.validate()) return;

    /*----------------------------------------------------*/
    /* Look through the list of options for the product.  */
    /* For any that are required, check to see if we have */
    /* a matching option in the selectedOptions list.     */
    /*----------------------------------------------------*/
    var invalidOptions = '';

    var requiredOptions = $ctrl.appCtrl.masterList.filter(function (mo) {
      return mo.required;
    });

    /** Utility function to check that the provided ProductListItem's required options have been fulfilled. */
    var verifyProductOption = function (pli) {
      /*-------------------------------------*/
      /* Process subItems if this is a group */
      /*-------------------------------------*/
      if (pli.type == IT_GROUP) {
        (pli.subItems || []).forEach(verifyProductOption);
        return;
      }

      if (!pli.itemOptions || !pli.itemOptions.length) return;

      /*--------------------------------------------*/
      /* Find the unique required options for the   */
      /* product looking at active itemOptions only */
      /*--------------------------------------------*/
      var reqProductOptionMap = {};
      pli.itemOptions.forEach(function (io) {
        if (reqProductOptionMap.hasOwnProperty(io.optionID) || !io.active)
          return;

        var masterOption = requiredOptions
          .filter(function (mo) {
            return mo.id == io.optionID;
          })
          .shift();

        if (masterOption) reqProductOptionMap[masterOption.id] = masterOption;
      });

      var reqProductOptions = Object.keys(reqProductOptionMap).map(
        (key) => reqProductOptionMap[key]
      );

      /*-------------------------------------------------------------*/
      /* Check to see if any required option was not set. If this is */
      /* the case add the option name to the invalidOptions string   */
      /*-------------------------------------------------------------*/
      reqProductOptions.forEach(function (mo) {
        if (
          ($ctrl.selectedOptions || []).filter(function (lio) {
            return lio.itemID == pli.id && lio.optionMasterID == mo.id;
          }).length == 0
        )
          invalidOptions += mo.name + '\n';
      });

      if (pli.subItems) {
        pli.subItems.forEach(verifyProductOption);
      }
    };

    verifyProductOption(mProduct);

    /*---------------------------------------------------*/
    /* If this invalidOptions string exists, then we can */
    /* display the alert and skip the rest of the code.  */
    /*---------------------------------------------------*/
    if (invalidOptions) {
      Alert.error(
        'Required option(s) not selected:\n' + invalidOptions,
        'Missing Required Options',
        { hide: true }
      );
      return;
    }

    /*-----------------------------------------*/
    /* Notify user of invalid quantity if      */
    /* there exists a qtyChange on any options */
    /*-----------------------------------------*/
    if (
      !$ctrl.isDonation() &&
      ($ctrl.selectedOptions || []).some(function (lio) {
        return lio.qtyChange > 0;
      }) &&
      $ctrl.receiptItem.quantity > 1
    ) {
      Alert.info(
        'This item does not allow multiple quantity purchases with the current options.',
        'Quantity Restricted'
      );
      document.getElementById('productQtyInput').focus();
      return;
    }

    /*--------------------------------------------------------------*/
    /* Set the appropriate properties for the receiptItem and any   */
    /* sub items. Group items can only be of the sale type as they  */
    /* are virtual items and will not be picked up. Quantity should */
    /* always be an integer, so make sure to remove any decimals.   */
    /*--------------------------------------------------------------*/
    var quantity = Math.trunc($ctrl.receiptItem.quantity);

    var setProps = function (ri) {
      // Get entity information safely
      var itemForEntity = $ctrl.itemFor && $ctrl.itemFor.entity;
      var entityExists = !!itemForEntity;

      // Set basic properties
      ri.type = ri.type || getItemType(ri.subType);
      ri.entity = entityExists ? itemForEntity : null;
      ri.entityID = entityExists ? itemForEntity.id : 0;
      ri.name = entityExists ? itemForEntity.name : null;
      ri.quantity = quantity;
      ri.backordered = ri.type === LIT_ITEM_ORDER ? quantity : 0;

      // Handle discount calculation for edits
      if ($ctrl.isEdit) {
        var originalDiscount = ri.discount || 0;
        var discountPerItem = mOrigQty ? originalDiscount / mOrigQty : 0;
        ri.discount = Tools.roundToPrecision(discountPerItem * quantity, 2);
      }

      // Filter and set options for this item
      ri.options = ($ctrl.selectedOptions || []).filter(function (option) {
        return option.itemID === ri.itemID;
      });

      // Apply the edited effective date to membership items only
      if ($ctrl.showEffectiveDate() && isMembershipReceiptItem(ri))
        ri.effectiveDate = $ctrl.effectiveDate
          ? new Date($ctrl.effectiveDate)
          : null;

      // Apply price adjustments from options
      ri.price += totalPriceChange(ri.options);

      // Recursively apply to sub-items
      if (ri.subItems) {
        ri.subItems.forEach(setProps);
      }
    };

    // Helper function to determine item type
    function getItemType(subType) {
      return forOrder && subType !== LIS_ITEM_GROUP
        ? LIT_ITEM_ORDER
        : LIT_ITEM_SALE;
    }

    /*-----------------------*/
    /* Update the receiptItem */
    /*-----------------------*/
    setProps($ctrl.receiptItem);

    /*-------------------------------------------------*/
    /* Set amount from price if the item is a donation */
    /*-------------------------------------------------*/
    if ($ctrl.isDonation()) $ctrl.receiptItem.amount = $ctrl.receiptItem.price;

    /*-----------------------------*/
    /* Add the item to the receipt */
    /*-----------------------------*/
    $ctrl.appCtrl.addReceiptItem($ctrl.receiptItem);

    /*---------------------*/
    /* Ready for new input */
    /*---------------------*/
    reset();
    focusOnProduct();
  }

  /*****************************************************************************
   * checkEntity */
  /**
   * Entity selection handler, called from the enter key or a blur. This will
   * utilize the validateEntity utility to handle the item for selection or
   * non-match and trigger the EntityMaker as needed.
   *****************************************************************************/
  $ctrl.checkEntity = function ($event) {
    if (!$ctrl.itemFor) return;

    $ctrl.appCtrl
      .validateEntity($ctrl.itemFor, $event.currentTarget, true)
      .then(function (entityInfo) {
        if (entityInfo?.data) {
          $ctrl.itemFor = entityInfo.data;
        } else {
          Alert.error('No individual found');
        }
      });
  };

  /** Disables the price field for editing. */
  $ctrl.disablePrice = function () {
    return mProduct && mProduct.fixedPrice && !$ctrl.isDonation();
  };

  /*****************************************************************************
   * focusOnProduct */
  /**
   * Puts the focus on the product input when the product tab is clicked. Timeout
   * is called so the tab can expand before the focus is called.
   *****************************************************************************/
  function focusOnProduct() {
    $timeout(function () {
      document.getElementById('productItem').focus();
    });
  }

  /*****************************************************************************
   * handleButtons */
  /**
   * Generic button handler. Makes sure that the EntityMake is not currently open.
   *
   * @param  event  Event that is holding the button that was clicked.
   *****************************************************************************/
  $ctrl.handleButtons = function (event) {
    switch (event.target.id) {
      case 'btnSale':
        addProduct();
        break;
      case 'btnOrder':
        addProduct(true);
        break;
      case 'btnUpdate':
        addProduct();
        break;
      case 'btnCancel':
        reset();
        break;
    }
  };

  /** Donation Item Indicator. */
  $ctrl.isDonation = function () {
    return mProduct && mProduct.type == IT_DONATION;
  };

  /** Quantity getter/setter to ensure only integers are saved. */
  $ctrl.itemQuantity = function (value) {
    if (value === null || value === undefined)
      return $ctrl.receiptItem.quantity;

    /*--------------------------------------*/
    /* Ensure we only save positive values. */
    /*--------------------------------------*/
    if (value <= 0) return;

    $ctrl.receiptItem.quantity = Math.trunc(value);
  };

  /*--------------------------------------------------*/
  /* Membership Item Indicator. When the current item */
  /* is a membership or a kit contains a membership.  */
  /*--------------------------------------------------*/
  $ctrl.isMembership = function () {
    return (
      mProduct &&
      (mProduct.type == IT_MEMBERSHIP ||
        (mProduct.type == IT_GROUP &&
          mProduct.subItems.some(function (si) {
            return si.type == IT_MEMBERSHIP;
          })))
    );
  };

  /*****************************************************************************
   * showEffectiveDate */
  /**
   * The effective date input is only available when editing a membership item
   * (or a kit containing one). New items get the product's effective date on
   * the server, so there is nothing to change until the item exists. Only
   * Bookkeepers and District Bookkeepers (Presidents and Treasurers in
   * PTA/Booster) may change it (enforced on save).
   *****************************************************************************/
  $ctrl.showEffectiveDate = function () {
    return (
      $ctrl.isEdit &&
      $ctrl.isMembership() &&
      $ctrl.appCtrl.allowItemEffectiveDateEdit()
    );
  };

  /*****************************************************************************
   * validateEffectiveDate */
  /**
   * Validator for the optional effective date input. Blank is allowed (the item
   * is saved without an effective date) but text that is not a date must block
   * the update. The model can't tell the two apart: dateInput turns text it
   * can't parse into a null model, the same as blank, and its isValid() never
   * reports an error, so date-validator would let it through. Check the typed
   * text with the same parser dateInput uses instead.
   *
   * @param  value  Effective date model value.
   * @return        Error message, null=valid.
   *****************************************************************************/
  $ctrl.validateEffectiveDate = function (value) {
    var input = document.querySelector('#productEffectiveDate input');
    var text = input ? input.value.trim() : '';

    return (value && isNaN(value)) || (text && !Tools.parseDate(text))
      ? 'Not a valid date'
      : null;
  };

  /*****************************************************************************
   * isMembershipReceiptItem */
  /**
   * Returns an indication that the receipt item (or kit subitem) is for a
   * membership product. The subType alone can't be trusted: the server only
   * reports LIS_MEMBERSHIP when the item's product is loaded, which it is not
   * for a saved receipt, so items from getReceipt come back as 0. Fall back to
   * the matching product from the selected product or its subitems.
   *
   * @param  ri  ReceiptItem to check.
   *****************************************************************************/
  function isMembershipReceiptItem(ri) {
    if (ri.subType == LIS_MEMBERSHIP) return true;
    if (!mProduct) return false;

    var product = [mProduct]
      .concat(mProduct.subItems || [])
      .filter(function (pli) {
        return pli.id == ri.itemID;
      })
      .shift();

    return !!product && product.type == IT_MEMBERSHIP;
  }

  /** Pass-through to loadEntityList on the receiptController. */
  $ctrl.loadEntityList = function (input) {
    return $ctrl.appCtrl.loadEntityList(input);
  };

  /*****************************************************************************
   * onItemBlur */
  /**
   * Blur event handler for the item field. This waits for the next digest
   * cycle to ensure the next DOM element has received focused. When a donation
   * product or membership item is available, the quantity field is hidden/disabled
   * so if it has focus currently, the focus needs to go on the 'For' input.
   *****************************************************************************/
  $ctrl.onItemBlur = function () {
    /*-----------------------------------------*/
    /* If the selectedProduct is not an        */
    /* object, clear the string from the input */
    /*-----------------------------------------*/
    typeof $ctrl.selectedProduct() != 'object'
      ? $ctrl.selectedProduct(null)
      : /*----------------------------------------*/
        /* Otherwise adjust the focus as necesary */
        /*----------------------------------------*/
        $timeout(function () {
          if (
            ($ctrl.isDonation() || $ctrl.isMembership()) &&
            document.activeElement == document.getElementById('productQtyInput')
          )
            document.getElementById('productItemFor').focus();
        });
  };

  /** Returns an indication that there are no item options. */
  $ctrl.noProductOptions = function () {
    return (
      !mProduct ||
      (mProduct.type == IT_GROUP &&
        !mProduct.subItems.some(function (si) {
          return (si.itemOptions || []).length > 0;
        })) ||
      (mProduct.type != IT_GROUP && !(mProduct.itemOptions || []).length)
    );
  };

  /** Pass-through to controller productList which returns a function to listen
    against. */
  $ctrl.productList = function () {
    return $ctrl.appCtrl.productList();
  };

  /** Entity field required indicator. An entity is required when there is a product
    and it doesn't allow anonymous sales or has sales limiters. */
  $ctrl.requiresFor = function () {
    return (
      mProduct &&
      (!mProduct.allowAnonymousSale ||
        (mProduct.limits &&
          (mProduct.limits.grade ||
            mProduct.limits.quantity ||
            mProduct.limits.balance)))
    );
  };

  /*****************************************************************************
   * reset */
  /**
   * Resets the filters and inputs for the next item selection.
   *****************************************************************************/
  function reset() {
    $ctrl.isEdit = false;
    mOrigQty = 0;
    $ctrl.receiptItem = {};
    mProduct = null;
    $ctrl.selectedOptions = null;
    $ctrl.itemFor = null;
    $ctrl.effectiveDate = null;

    if ($ctrl.valProduct.reset) $ctrl.valProduct.reset();
  }

  /*****************************************************************************
   * startEdit */
  /**
   * Starts editing the item by setting the input to the item from the event.
   *
   * @param  event  Event dispatched
   * @param  dgItem DGReceiptItem to modify
   *****************************************************************************/
  function startEdit(event, dgItem) {
    /*-----------------------------------------------------------------*/
    /* Set product to populate available options and rules for editing */
    /*-----------------------------------------------------------------*/
    $ctrl.isEdit = false;
    $ctrl.selectedProduct(dgItem.productSource);

    /*-------------------------------------------------*/
    /* Set flag after so the product cannot be changed */
    /*-------------------------------------------------*/
    $ctrl.isEdit = true;

    /*--------------------------------------------------*/
    /* Store original quantity for discount calculation */
    /*--------------------------------------------------*/
    mOrigQty = dgItem.quantity || 0;

    /*------------------------------------------------------*/
    /* Create a deep copy of item so the original item      */
    /* will not be modified. While creating the copy, grab  */
    /* the options to populate the selectedOptions property */
    /*------------------------------------------------------*/
    var flatOptionList = [];
    var generateReceiptItemCopy = function (ri) {
      var newItem = angular.extend({}, ri);

      /*------------------*/
      /* Copy the options */
      /*------------------*/
      newItem.options = (ri.options || []).map(function (lio) {
        return angular.extend({}, lio);
      });

      /*-------------------------------------*/
      /* Remove price change from item price */
      /* as it will be updated on the update */
      /*-------------------------------------*/
      newItem.price = Tools.roundToPrecision(
        newItem.price - totalPriceChange(ri.options),
        2
      );

      /*-------------------*/
      /* Generate subitems */
      /*-------------------*/
      newItem.subItems = (ri.subItems || []).map(generateReceiptItemCopy);

      /*--------------------------*/
      /* Update total option list */
      /*--------------------------*/
      flatOptionList = flatOptionList.concat(newItem.options);

      return newItem;
    };

    /*----------------------*/
    /* Update UI properties */
    /*----------------------*/
    $ctrl.receiptItem = generateReceiptItemCopy(dgItem.source());
    $ctrl.selectedOptions = flatOptionList;

    /*-------------------------------------------------------*/
    /* Seed the effective date input from the membership     */
    /* item, which is a subitem when the item is a kit.      */
    /*-------------------------------------------------------*/
    var membershipItem = [$ctrl.receiptItem]
      .concat($ctrl.receiptItem.subItems)
      .filter(isMembershipReceiptItem)
      .shift();

    $ctrl.effectiveDate =
      membershipItem && membershipItem.effectiveDate
        ? new Date(membershipItem.effectiveDate)
        : null;

    /*----------------------------------------------------------*/
    /* If this is a group edit, update the group price to       */
    /* reflect the total price from the subitems as there could */
    /* have been option price changes that affected the prices  */
    /*----------------------------------------------------------*/
    if (dgItem.isGroup()) {
      $ctrl.receiptItem.price = 0;
      $ctrl.receiptItem.subItems.forEach(function (si) {
        $ctrl.receiptItem.price = Tools.roundToPrecision(
          $ctrl.receiptItem.price + si.price,
          2
        );
      });
    }

    /*----------------------------------*/
    /* If this is a donation item edit, */
    /* set the price to the item amount */
    /*----------------------------------*/
    if ($ctrl.isDonation()) $ctrl.receiptItem.price = $ctrl.receiptItem.amount;

    /*-----------------*/
    /* Set the ItemFor */
    /*-----------------*/
    if ($ctrl.receiptItem.entityID)
      $ctrl.appCtrl
        .getAddressEntityListItem($ctrl.receiptItem.entityID)
        .then(function (entity) {
          $ctrl.itemFor = entity;
        });
    else $ctrl.entity = null;
  }

  /*****************************************************************************
   * totalPriceChange
   *
   * Totals the priceChange property from the array of <b>LedgerItemOptions</b>.
   *
   * @param   options Array of <b>LedgerItemOptions</b>
   * @return          Numeric priceChange property total
   *****************************************************************************/
  function totalPriceChange(options) {
    var priceChange = 0;
    (options || []).forEach(function (lio) {
      priceChange = Tools.roundToPrecision(
        priceChange + (lio.priceChange || 0),
        2
      );
    });

    return priceChange;
  }
}
